import { ScrollReveal } from '@podus/ui';

export default function WhereWeAre() {
    return (
        <section className="px-4 py-10 lg:px-16 lg:py-24 xl:px-20">
            <div className="mx-auto flex max-w-480 flex-col gap-10 lg:flex-row lg:items-center lg:gap-16">
                {/* Map */}
                <ScrollReveal variant="fade-right" delay={0} distance={30} className="lg:w-[55%]">
                    <div className="relative">
                        <img
                            src="/assets/podus_ai_map.png"
                            alt="Podus coverage map showing Nigeria, Ghana, and the UK"
                            className="w-full object-contain"
                        />
                    </div>
                </ScrollReveal>

                {/* Text */}
                <ScrollReveal variant="fade-left" delay={200} distance={30} className="lg:w-[45%]">
                    <div>
                        <h2 className="text-[28px] font-extrabold leading-[1.1] tracking-tight text-secondary sm:text-[36px] lg:text-[44px] xl:text-[56px]">
                            Where we are
                        </h2>
                        <p className="mt-5 text-[15px] leading-[2] text-[#4E4D4D] lg:mt-6">
                            From West Africa to the United Kingdom, Podus is building a connected ecosystem that bridges
                            law, technology, and people. Whether it's providing AI-driven legal guidance, contract
                            management, or human rights protection, we're creating equal access to justice across
                            Nigeria, Ghana, and the UK — and soon, beyond.
                        </p>
                    </div>
                </ScrollReveal>
            </div>
        </section>
    );
}
